import {Page} from '@entities/left-panel/left-panel.interface';
import {DataStorageHelper} from 'amc-common-components';

/**
 * 'LeftPanelHelper' class definition.
 */
export class LeftPanelHelper {
	/** Auxiliary 'PAGE_IDS' variable. */
	static readonly PAGE_IDS = {
		rights: 'rights',
		ctsDistribution: 'cts_distribution',
	};

	/** Auxiliary 'NO_CLOUDANT_PAGES' variable. */
	static readonly NO_CLOUDANT_PAGES = [LeftPanelHelper.PAGE_IDS.rights];

	/**
	 * Get rights page.
	 * @returns {Page}
	 */
	private static getRightsPage(): Page {
		return {
			id: LeftPanelHelper.PAGE_IDS.rights,
			name: 'Rights & Avails',
			icon: 'chart-pie',
			url: 'rights',
			disabled: false,
			subPages: [],
		};
	}

	/**
	 * Get cts-distribution page.
	 * @returns {Page}
	 */
	private static getCtsDistributionPage(): Page {
		return {
			id: LeftPanelHelper.PAGE_IDS.ctsDistribution,
			name: 'CTS Distribution',
			icon: 'sitemap',
			url: 'cts-distribution',
			disabled: false,
			subPages: [],
			isHidden: !DataStorageHelper.isPortal(),
		};
	}

	/**
	 * Get security page.
	 * @returns {Page}
	 */
	static getPages(): Page[] {
		return [LeftPanelHelper.getRightsPage(), LeftPanelHelper.getCtsDistributionPage()];
	}
}
